import { Item } from './types';
// @ts-ignore
import { shouldApplyItemFeeByServiceType } from '@vmos2/price';

export const getFeeItem = (items: Item[], isTakeAway: boolean) => items?.find(item => item.isFee && shouldApplyItemFeeByServiceType(item, isTakeAway));
